import React,{useEffect, useState} from 'react';
import pattern4 from "../../Images/Shape-6.png";
import work1 from "../../Images/work1.png";
import work2 from "../../Images/work2.png";
import work3 from "../../Images/work3.png";

export default function Space(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () =>window.removeEventListener("scroll", handleScroll);
    },[])
    return(
        <div className="Space">
            <img src={pattern4} className="paral3" 
                 style={{transform: `translateY(-${offsetY * 0.5}px)`}} 
                 />
            <img src={pattern4} className="paral4" 
            style={{transform: `translateY(${offsetY * 0.2}px)`}} />
            <div className="company-mark" >
                <img src={work1} className="comp-mark" data-aos="fade-up" />
                <img src={work3} className="comp-mark long" data-aos="fade-up" data-aos-delay="300"/>
                <img src={work2} className="comp-mark" data-aos="fade-up" data-aos-delay="600"/>
            </div>
        </div>
    )
}